"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useLockedBody = require("./useLockedBody");
Object.keys(_useLockedBody).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useLockedBody[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useLockedBody[key];
    }
  });
});